import ccth from "./assets/icons/logo1.png";
import tero from "./assets/icons/newTero.png";
import su from "./assets/icons/su.png";
import suWhite from "./assets/icons/whitelogo.png"
import critLogo from "./assets/icons/critLogo.png"
import pbp from "./assets/icons/pbp.png"
import pokagon from "./assets/icons/pokagon.png"
import klamath from "./assets/icons/klamathtribeslogo.png"
// Color schemes for each app
export const colorSchemes = {
  "My Tlingit & Haida Portal": {
    primary: "#8A0B14",      
    secondary: "#2a2a2a",    
    background: "#1C1C1C",   
  },
  "TERO": {
    primary: "#840028",     
    secondary: "#a00034",   
    background: "#4b0c33",  
  },
  "POK": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
  "Suquamish": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
  "Colorado River Indian Tribes": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
  "Prairie Band Potawatomi Nation": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
  "Pokagon Band of Potawatomi": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
  "Klamath Tribes": {
    primary: "#840028",
    secondary: "#a00034",
    background: "#4b0c33",
  },
};

const appConfig = {
    "portal": {
      name: "My Tlingit & Haida Portal",
      logo: ccth,
    },
    "teroportal": {
      name: "TERO",
      logo: tero,
    },
    // "pokagonportal": {
    //     name: "POK",
    //     logo: tero,
    // },
    "sqportal":{
      name: "Suquamish",
      logo: su,
      whitelogo : suWhite
    },
    "critportal": {
      name: "Colorado River Indian Tribes",
      logo: critLogo,
    },
    "pbpportal": {
      name: "Prairie Band Potawatomi Nation",
      logo: pbp,
    },
    "pokagonportal": {
      name: "Pokagon Band of Potawatomi",
      logo: pokagon,
    },
    "klportal": {
      name: "Klamath Tribes",
      logo: klamath,
    }
  };

// Utility function to set CSS variables based on appName
export const setThemeColors = (appName) => {
  const colors = colorSchemes[appName] || colorSchemes["TERO"]; // Default to TERO if not found
  const root = document.documentElement;
  root.style.setProperty("--color-primary", colors.primary);
  root.style.setProperty("--color-secondary", colors.secondary);
  root.style.setProperty("--color-background", colors.background);
};
  
// Helper to resolve the current portal key, preferring StyleFolder from settings
export const getPortalKey = () => {
  // 1. Try StyleFolder from cached portal settings
  try {
    const savedSettings = sessionStorage.getItem("portalSettings");
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      if (settings?.StyleFolder) {
        const styleKey = settings.StyleFolder.toLowerCase();

        // Prefer exact StyleFolder key if present
        if (appConfig[styleKey]) return styleKey;

        // Common pattern: VirtualDirectory = StyleFolder + "portal"
        const portalKeyFromStyle = `${styleKey}portal`;
        if (appConfig[portalKeyFromStyle]) return portalKeyFromStyle;
      }
    }
  } catch (e) {
    // Ignore and fall back to URL-based logic
  }

  // 2. Fallback: derive from first path segment
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  return pathSegments[0] || "portal";
};

// Helper to get the active app config based on current portal
export const getPortalConfig = () => {
  const key = getPortalKey();
  return appConfig[key] || appConfig.portal;
};

export default appConfig;
  